import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RestDataService, StatusBarService, UnitsService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-booster-detail',
  templateUrl: './booster-detail.component.html',
  styleUrls: ['./booster-detail.component.css']
})
export class BoosterDetailComponent implements OnInit, OnChanges {

  @Input() boosterId:string=null;
  boosterDetails=null;
  status;

  constructor(public unitsService:UnitsService,private statusBarService:StatusBarService,private restDataService:RestDataService) { 
    this.status = this.statusBarService.statusLoading("Loading Booster details ");
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(!this.boosterId){return;}    
    this.status = this.statusBarService.statusLoading("Loading Booster details ");
    this.boosterDetails=null;     
    this.status = this.statusBarService.statusLoading("Loading Booster details");
    this.restDataService.get(this.restDataService.addIdToURL(this.boosterId,environment.boosterDetailsURL)).subscribe((boosterDetails:any)=>{
      this.boosterDetails=boosterDetails;
      this.status = this.statusBarService.clear();
    })
  }

  ngOnInit(): void {
  }


}
